import { useState } from 'react';
import { LinkButton, LocalizedPageTitle, LocalizedParagraph, OptimusProvider } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Banner, IconName, Stack } from '@optimus-web/core';
import { NewPublicFormWrapper } from '../style';
import { ResetPasswordForm } from './ResetPasswordForm';

export const ResetPassword = () => {
    const [userEmail, setUserEmail] = useState<string | null>(null);

    const onFormSuccess = (email: string) => {
        setUserEmail(email);
    };

    return (
        <NewPublicFormWrapper>
            <OptimusProvider density="spacious">
                {userEmail === null ? (
                    <Stack spacing="100" vertical>
                        <LocalizedPageTitle textKey={TextKey.ForgotPasswordQuestion} />
                        <Stack spacing="500" vertical>
                            <LocalizedParagraph textKey={TextKey.ForgotPasswordInstructions} variant="secondary" />
                            <ResetPasswordForm onFormSuccess={onFormSuccess} />
                        </Stack>
                    </Stack>
                ) : (
                    <Stack spacing="500" vertical>
                        <LocalizedPageTitle textKey={TextKey.ForgotPasswordQuestion} />
                        <Banner
                            variant="success"
                            primaryText={<LocalizedText textKey={TextKey.CheckYourEmail} />}
                            secondaryText={
                                <LocalizedText
                                    textKey={TextKey.PasswordResetEmailMessage}
                                    substitutes={{ emailAddress: userEmail }}
                                />
                            }
                        />
                        <LinkButton to="/Home/SignIn" icon={IconName.ArrowLeft} wide>
                            <LocalizedText textKey={TextKey.BackToLogin} />
                        </LinkButton>
                    </Stack>
                )}
            </OptimusProvider>
        </NewPublicFormWrapper>
    );
};
